import React from "react";
import { profileImgPlaceholder } from "../../../../assets/images";
import { Domain, request } from "../../../../config/API";
import { COLORS } from "../../../../config/theme";
import MainIconBar from "../MainIconBar";
import InfoBox from "../InfoBox";
import renderSocialIcon from "../../components/rederSocialIcons";
import ButtonBar from "../ButtonBar";
import { ReactComponent as Vector } from "./Vector.svg";
import { Col, Row } from "antd";
import SocialIconBar from "../SocialIconBar";

const Theme6 = ({ vCard, isPreview, downloadVcfFile, setShowExchangeCard }) => {
  const { primaryColor } = COLORS;
  const {
    fNamePrefix,
    fName,
    lName,
    lNameSuffix,
    email,
    company,
    jobTitle,
    mobile,
    address,
    bgImage,
    profileImage,
    pColor,
    sColor,
    socialLinks,
    leadEnable,
    owner,
    webLinks,
  } = vCard;
  return (
    <Col style={{ width: "100%", backgroundColor: sColor }}>
      <Col
        style={{
          position: "relative",
          minHeight: "25rem",
          background: `linear-gradient(to bottom, rgba(0, 0, 0, 0.1), rgba(0, 0,0, 0.8)),
          ${bgImage ? `url(${Domain}/data/${bgImage})` : pColor}`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          overflow: "hidden",
          backgroundPosition: "center",
        }}
        span={24}
      >
        <Row
          style={{
            position: "absolute",
            bottom: -10,
            left: -5,
          }}
          span={24}
        >
          <Vector fill={sColor} style={{}} />
        </Row>
        <Row
          span={24}
          style={{
            position: "absolute",
            display: "flex",
            width: "100%",
            bottom: 20,
          }}
        >
          <Col span={12}>
            <Row
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <img
                draggable={false}
                style={{
                  height: "8rem",
                  width: "7.5rem",
                }}
                src={
                  profileImage
                    ? `${Domain}/data/${profileImage}`
                    : profileImgPlaceholder
                }
                alt=""
              />
            </Row>
          </Col>
          <Col
            span={12}
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <Row
              style={{
                display: "flex",
              }}
              span={12}
            >
              <InfoBox
                fName={fName}
                jobTitle={jobTitle}
                company={company}
                black={false}
              />
            </Row>
            <Row
              style={{
                display: "flex",
                marginTop: 20,
              }}
              span={12}
            >
              <MainIconBar
                mobile={mobile}
                email={email}
                address={address}
                sColor={sColor}
                horizontal={true}
              />
            </Row>
          </Col>
        </Row>
      </Col>
      <SocialIconBar
        socialLinks={socialLinks}
        leadEnable={leadEnable}
        sColor={sColor}
        downloadVcfFile={downloadVcfFile}
        setShowExchangeCard={setShowExchangeCard}
        owner={owner}
        isBlack={false}
        webLinks={webLinks}
        isPreview={isPreview}
      />
    </Col>
  );
};

export default Theme6;
